module.exports = __webpack_public_path__ + "static/warforged-trio-6c108d5938093950df8005ec824f8b85.png";